<script setup lang="ts">
import { LanguageSelector } from 'r3ui-lib';
import Cookies from 'js-cookie';
import { getBrowserLocale } from '~/utils/helpers';

const { locale, locales, setLocale } = useI18n();
const savedLocale = Cookies.get('i18n_redirected');
const defaultLocale = savedLocale || getBrowserLocale();
const localeModel = ref(defaultLocale);

interface LocaleOption {
  code: string;
  name: string;
}

function setLocaleHandler(e: string) {
  if (e === locale.value) return false;
  setLocale(e as typeof locale.value);
  window.location.reload();
}

const localeOptions = computed(() => {
  return (locales.value as LocaleOption[]).map(i => {
    return {
      id: i.code,
      label: i.name,
    };
  });
});
</script>

<template>
  <LanguageSelector
    v-model="localeModel"
    :options="localeOptions"
    @update:model-value="setLocaleHandler"
  />
</template>
